import { useQuery } from "react-query";
import { QUERY_KEYS } from "../../constants/queries";
import { HealthControllerApiFp } from "../../api/generated/v1.0/open";
import { useMemo } from "react";
import { useAxios } from "./useAxios";

export const useHealth = () => {
  const axios = useAxios();
  const { status: healthCheckStatus } = useQuery(
    [QUERY_KEYS.health],
    async () => {
      await (
        await HealthControllerApiFp().healthUsingGET()
      )(axios);
    },
    {
      // refetch once every minute
      refetchInterval: 60000,
    }
  );

  const healthCheckFailed = useMemo(
    () => healthCheckStatus === "error",
    [healthCheckStatus]
  );

  const healthCheckSucceeded = useMemo(
    () => healthCheckStatus === "success",
    [healthCheckStatus]
  );

  return { healthCheckStatus, healthCheckFailed, healthCheckSucceeded };
};
